module.exports = __webpack_public_path__ + "static/media/11-Dresden@2x.182100af.jpg";